import {
  Autocomplete,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { DataAutocomplete } from '../../SelectResponsibles';
import { InputProps } from '../Input';
import clsx from 'clsx';

type AutocompleteProps = {
  name: string;
  values: DataAutocomplete[];
  placeholder?: string;
  startAdornment?: JSX.Element;
  disabled?: boolean;
  CustomOnChange?: (event: object, value: DataAutocomplete | null) => void;
};

export function InputAutocomplete({
  name,
  label,
  values,
  placeholder,
  disabled,
  CustomOnChange,
  startAdornment,
  ...props
}: InputProps & AutocompleteProps) {
  const methods = useFormContext();

  return (
    <FormControlLabel
      labelPlacement="top"
      label={
        <Typography
          className={clsx(
            { 'text-mui-error': methods.formState.errors[name] },
            'ml-6 mb-1 font-bold'
          )}
          alignSelf="start"
        >
          {label}
          {props.rules?.required && !disabled && (
            <span className="ml-1 text-mui-error">*</span>
          )}
        </Typography>
      }
      className="w-full m-0"
      control={
        <Controller
          {...props}
          name={name}
          render={({ field, fieldState: { error } }) => (
            <Autocomplete
              {...field}
              disabled={disabled}
              noOptionsText={'Sem opções'}
              fullWidth
              size="small"
              options={values}
              getOptionLabel={(option) => option.displayName}
              isOptionEqualToValue={(option, value) =>
                option.displayName === value.displayName
              }
              onChange={CustomOnChange || field.onChange}
              renderInput={({ InputProps, ...params }) => (
                <TextField
                  placeholder={placeholder}
                  error={!!error}
                  helperText={error?.message}
                  InputProps={{
                    ...InputProps,
                    startAdornment,
                  }}
                  {...params}
                />
              )}
            />
          )}
        />
      }
    />
  );
}
